import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { Download, isProduct, Product } from '../../model';
import { DownloadStore } from '../../shared/services/download-store';
import { RouteLocatorService } from '../../shared/services/route-locator.service';
import { DacklBreakpoint, DacklBreakpointObserver, DacklEmptyStateComponent } from '@datev/ngx-dackl';
import {MatAnchor, MatButton} from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { MatChip } from '@angular/material/chips';
import { DownloadInfoCardComponent } from '../download-info-card/download-info-card.component';
import { ProductDocViewComponent } from '../product-doc-view/product-doc-view.component';
import { PushPipe } from '@ngrx/component';
import { RouterLink } from '@angular/router';


type DownloadWithProductGroupLabel = Product;

@Component({
    selector: 'dp-download-details-page-content',
    templateUrl: './download-details-page-content.component.html',
  imports: [
    RouterLink,
    MatAnchor,
    MatIcon,
    MatCard,
    MatChip,
    DownloadInfoCardComponent,
    ProductDocViewComponent,
    DacklEmptyStateComponent,
    PushPipe,
    MatButton,
  ],
})
export class DownloadDetailsPageContentComponent {
  @Input() download: Download | null | undefined;
  @Input() backLinkUrl: string = '..';
  @Input() backLinkLabel: string = 'Zurück';

  @ViewChild('backLink', { read: ElementRef })
  set backLink(backLink: ElementRef<HTMLElement> | undefined) {
    backLink?.nativeElement.focus();
  }

  shouldDisplayDetailView$: Observable<boolean> =
    this.pilotCustomizationService.isOnPilotToggleRelevantDetailPage$.pipe(
      map(isOnDetailsPage => !isOnDetailsPage),
    );

  constructor(
    private readonly downloadStore: DownloadStore,
    private readonly pilotCustomizationService: RouteLocatorService,
    private readonly dacklBreakpointObserver: DacklBreakpointObserver,
  ) {}

  /**
   * selects the product when the breakpoint is larger than MD, otherwise the right-aside would overlay the contents
   * when the user returns to the list view.
   *
   * @param download
   */
  async selectDownload(download: Download): Promise<void> {
    const breakpoint = await firstValueFrom(this.dacklBreakpointObserver.breakpoint$);
    if (breakpoint > DacklBreakpoint.MD) {
      this.downloadStore.setSelectedDownload(download);
      this.downloadStore.requestDetailLinkFocus();
    }
  }

  hasProductGroupLabel(
    download: Download,
  ): download is DownloadWithProductGroupLabel {
    return isProduct(download);
  }
}
